import H_task from '@/helpers/task';
import H_taskTemplate from '@/helpers/taskTemplate';

const listColumnHeader = [
  {
    id: 'updateDate',
    textLabel: '建立日期',
    type: 'text',
    tabletHide: false,
    width: '120px',
  },
  {
    id: 'condition',
    textLabel: '狀態',
    type: 'badge',
    tabletHide: false,
    width: '10%',
  },
  {
    id: 'multiSystemClasses',
    textLabel: '領域',
    type: 'chips',
    tabletHide: false,
  },
  {
    id: 'name',
    textLabel: '主旨',
    type: 'text-chip',
    tabletHide: false,
  },
  {
    id: 'toDoItem',
    textLabel: '待辦事項',
    type: 'toDoItem',
    tabletHide: true,
  },
  {
    id: 'taker',
    textLabel: '負責人',
    type: 'avatar',
    tabletHide: false,
    width: '15%',
  },
  {
    id: 'deadline',
    textLabel: '期限',
    type: 'time',
    tabletHide: false,
    textAlignLeft: 'left',
    width: '130px',
  },
];

const listFilterFieldTypes = [
  {
    name: 'search',
    type: 'search',
  },
  {
    name: 'orderWay',
    type: 'radio-dropdown',
    title: '排序',
    btnIcon: 'icon-nav-add-audit',
    defaultValue: 'created_at',
    items: [
      {
        id: 'created_at',
        textLabel: '依建立日期由近至遠',
      },
      {
        id: 'expired_at',
        textLabel: '依期限由舊至新',
      },
      {
        id: 'complete',
        textLabel: '依完成度由低至高',
      },
    ],
  },
  {
    name: 'systemSubclasses',
    type: 'two-layer-dropdown',
  },
  {
    name: 'factorySystemClasses',
    type: 'two-layer-dropdown',
  },
  {
    name: 'createdAt',
    type: 'date-duration',
    title: '建立日期',
    defaultValue: {
      start: '',
      end: '',
    },
  },
  {
    name: 'factoryTags',
    type: 'one-layer-dropdown',
  },
];

const templateListColumnHeader = [
  {
    id: 'systemSubclasses',
    textLabel: '領域',
    type: 'chips',
    tabletHide: false,
  },
  {
    id: 'name',
    textLabel: '主旨',
    type: 'text-chip',
    tabletHide: false,
  },
];

const templateListFilterFieldTypes = [
  {
    name: 'search',
    type: 'search',
  },
  {
    name: 'status',
    type: 'radio-dropdown',
    title: '狀態',
    defaultValue: 'released,draft',
    disableCancel: true,
    items: [
      {
        id: 'released,draft',
        textLabel: '全部',
      },
      {
        id: 'released',
        textLabel: '已發布',
      },
      {
        id: 'draft',
        textLabel: '草稿',
      },
    ],
  },
  {
    name: 'systemSubclasses',
    type: 'two-layer-dropdown',
  },
  {
    name: 'factorySystemClasses',
    type: 'two-layer-dropdown',
  },
  {
    name: 'factoryTags',
    type: 'one-layer-dropdown',
  },
];

const listContentTabs = [
  {
    id: 'inProgress',
    textLabel: '進行中',
    num: 0,
  },
  {
    id: 'audited',
    textLabel: '待審核',
    num: 0,
  },
  {
    id: 'complete',
    textLabel: '已完成',
  },
  {
    id: 'all',
    textLabel: '全部',
  },
];

const taskIndexConfig = new Map([
  [
    'list',
    {
      title: '任務',
      needTask: true,
      needTemplate: false,
      fetchUrl: 'task',
      createUrl: 'task-create',
      createScopes: ['task-create'],
      columnHeader: listColumnHeader,
      filterFieldTypes: listFilterFieldTypes,
      contentTabs: listContentTabs,
      fetchTabAmountUrl: 'task/tab_index',
      setListData: H_task.setIndex,
    },
  ],
  [
    'templateList',
    {
      title: '任務公版',
      needTask: false,
      needTemplate: true,
      fetchUrl: 'task_factory_template',
      createUrl: 'task-factory-template-create',
      createScopes: ['task-factory-template-create'],
      filterFieldTypes: templateListFilterFieldTypes,
      setListData: H_taskTemplate.setIndex,
    },
  ],
  [
    'collectedTemplateList',
    {
      title: '常用公版',
      needTask: false,
      needTemplate: true,
      fetchUrl: 'collect/task_factory_template',
      filterFieldTypes: templateListFilterFieldTypes,
      setListData: H_taskTemplate.setIndex,
    },
  ],
]);

export default {
  index: {
    config: taskIndexConfig,
    createTaskPopupConfig: {
      columnHeader: templateListColumnHeader,
      setListData: H_taskTemplate.setIndexDataTable,
      filterFieldTypes: templateListFilterFieldTypes.flatMap(item =>
        item.name === 'status' ? [] : [{ ...item, cols: 6 }],
      ),
      setParams: H_taskTemplate.setParamsDataTable,
      fetchUrl: taskIndexConfig.get('templateList').fetchUrl,
    },
  },
  typeRadioItems: {
    buttonItems: [
      {
        id: 'domain',
        textLabel: 'ESGoal連結',
      },
      {
        id: 'custom',
        textLabel: '自訂',
      },
    ],
  },
  draftTableHeader: [
    {
      id: 'name',
      textLabel: '主旨',
      type: 'text',
      width: '25%',
    },
    {
      id: 'updatedAt',
      textLabel: '編輯時間',
      type: 'text',
      width: '100px',
      noWrap: true,
    },
    {
      id: 'rowItembutton',
      type: 'rowItembutton',
      width: '10%',
      align: 'right',
    },
  ],
  createChooseList: [
    {
      id: 'task',
      name: '直接建立',
    },
    {
      id: 'template',
      name: '引用公版',
    }
  ],
  subTaskVisibilityDropdownItems: [
    {
      id: 'system_subclass',
      textLabel: '依待辦領域',
    },
    {
      id: 'taker',
      textLabel: '限執行者',
    },
    {
      id: 'all',
      textLabel: '所有待辦',
    },
  ],
  importCheckboxList: [
    {
      text: '沿用「任務負責人」',
      value: 'useTaskTaker',
    },
    {
      text: '沿用「待辦執行者」',
      value: 'useSubtaskTaker',
    },
  ],
}
